import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const domSelectorsSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'domSelectors'

export const config = {
	site: domSelectorsSiteConfig,
	reactRendererSite: domSelectorsSiteConfig,
	reactNativeSite: domSelectorsSiteConfig,
	name,
}
